import { motion } from "framer-motion";
import { Check, X } from "lucide-react";

const ROWS = [
  { label: "HOW YOU LEARN", lima: "Live shoots inside a working production house", online: "Videos you watch alone", school: "Lecture-hall theory" },
  { label: "WHO TEACHES YOU", lima: "Working editors, DOPs & the founder", online: "Little or none", school: "Full-time lecturers" },
  { label: "WHAT YOU LEARN", lima: "Mapped to what studios actually hire for", online: "Feature walkthroughs", school: "A years-old syllabus" },
  { label: "REAL-WORLD EXPOSURE", lima: "Client briefs & our hiring network", online: "None", school: "Occasional, if any" },
  { label: "AFTER YOU GRADUATE", lima: "Placement assistance, portfolio site & career kit", online: "A completion badge", school: "A noticeboard" },
  { label: "WHAT YOU WALK OUT WITH", lima: "A reel of real client work", online: "Notes and a badge", school: "A certificate" },
];

export default function ComparisonSection() {
  return (
    <section className="bg-lima-cream text-lima-ink px-5 md:px-10 py-14 md:py-32 border-t border-black/10" data-testid="comparison-section">
      <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.98] mb-10 md:mb-20">
        Most courses teach software.
        <br />
        <span className="font-serifit font-normal text-[#3a3a36]">We train you for the set.</span>
      </h2>
      <motion.div
        initial={{ opacity: 0, y: 30, filter: "blur(12px)" }}
        whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="overflow-x-auto"
      >
        <table className="w-full min-w-[720px] text-sm border border-black/15" data-testid="comparison-table">
          <thead>
            <tr className="border-b border-black/15 font-mono2 text-[11px] tracking-[0.2em] text-left">
              <th className="p-4 md:p-5 text-black/40 font-medium w-1/4"></th>
              <th className="p-4 md:p-5 bg-lima-blue text-white font-bold">LIMA</th>
              <th className="p-4 md:p-5 text-black/50 font-medium">ONLINE COURSES</th>
              <th className="p-4 md:p-5 text-black/50 font-medium">TRADITIONAL SCHOOLS</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map((r) => (
              <tr key={r.label} className="border-b border-black/10 last:border-0" data-testid={`comparison-row-${r.label.toLowerCase().replace(/\s/g, "-")}`}>
                <td className="p-4 md:p-5 font-mono2 text-[11px] tracking-[0.15em] text-black/50">{r.label}</td>
                <td className="p-4 md:p-5 bg-lima-blue/[0.06] font-semibold text-lima-ink">
                  <span className="flex items-start gap-2"><Check size={14} className="text-lima-blue shrink-0 mt-0.5" />{r.lima}</span>
                </td>
                <td className="p-4 md:p-5 text-black/50">
                  <span className="flex items-start gap-2"><X size={14} className="text-black/30 shrink-0 mt-0.5" />{r.online}</span>
                </td>
                <td className="p-4 md:p-5 text-black/50">
                  <span className="flex items-start gap-2"><X size={14} className="text-black/30 shrink-0 mt-0.5" />{r.school}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </motion.div>
    </section>
  );
}
